"use strict";

var _require = require('../../../helpers'),
    computeExactQuantity = _require.computeExactQuantity,
    computeRoundedQuantity = _require.computeRoundedQuantity,
    computeCopies = _require.computeCopies;

var _require2 = require('../../../../products/components'),
    TableNumber = _require2.TableNumber,
    WeddingSign = _require2.WeddingSign,
    CustomSign = _require2.CustomSign;

module.exports = function (accumulator, order, product, component) {
  var exactNum = computeExactQuantity(component);
  var roundedQuantity = computeRoundedQuantity(component);
  var copies = computeCopies(component);
  var doubledCopies = copies * 2;
  var up = component.up;
  var text;

  if (component.has_variable_data) {
    if (Object.prototype.isPrototypeOf.call(TableNumber.prototype, component) || Object.prototype.isPrototypeOf.call(CustomSign.prototype, component) || Object.prototype.isPrototypeOf.call(WeddingSign.prototype, component)) {
      text = exactNum + ' (' + up + 'up, ' + copies + ' pages, 2 copies each page) - VARIABLE DATA';
    } else {
      text = exactNum * 2 + ' (' + up + 'up, ' + copies + ' pages, 2 copies each page) - VARIABLE DATA';
    }
  } else {
    text = "".concat(roundedQuantity, " (").concat(up, "up, ").concat(doubledCopies, " ").concat(doubledCopies > 1 ? 'copies' : 'copy', ")");
  }

  return accumulator + text;
};